import { AdminService } from 'app/API';
import type { TCall } from './types/TCall';

type TParams = {
  call: TCall;
  uid: string;
  role: string;
  value: boolean;
};

export const updateAdminRole = async ({ call, uid, role, value }: TParams) => {
  const response = await call(() => AdminService.toggleAdminRole({ uid, requestBody: { role, value } }));

  if (!response.success) {
    throw new Error(response.error ?? response.message ?? 'Unable to update admin permissions.');
  }

  return response;
};
